import React from 'react';
import { Outlet } from 'react-router-dom';

const PuenteLogin = () => {
  return <Outlet />;
};

export default PuenteLogin;